import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  filtro?: boolean;
}

export function useListarOrigensLeads(props: Props) {
  const fetchData = async () => {
    const LISTAR_ORIGENS = `${leadsWebEnviroment}/mobile/origens-leads/v1?&Filtro=${
      props?.filtro ?? false
    }`;
    const response = await instance.get(LISTAR_ORIGENS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_origens"],
    refetchOnMount: false,
    enabled: false,
    cacheTime: 0,
  });
  return query;
}
